import { UploadCloud, X } from 'lucide-react';

const StepPhotos = ({ 
  photoFiles, 
  photoPreviews, 
  existingPhotos, 
  handlePhotoSelect, 
  removePhoto, 
  removeExistingPhoto 
}) => {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-4">
          Add Photos (up to 10) *
        </label>
        <div
          className="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center cursor-pointer hover:border-emerald-500 transition-colors"
          onClick={() => document.getElementById('photo-upload').click()}
        >
          <UploadCloud className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-sm text-gray-600 mb-2">
            <span className="font-medium text-emerald-700">Click to upload</span> or drag and drop
          </p>
          <p className="text-xs text-gray-500">PNG, JPG up to 10MB each</p>
          <input
            id="photo-upload"
            type="file"
            multiple
            accept="image/*"
            className="hidden"
            onChange={handlePhotoSelect}
          />
        </div>
      </div>

      {/* Existing Photos */}
      {existingPhotos.length > 0 && (
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">Current Photos</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {existingPhotos.map((photoUrl, index) => (
              <div key={index} className="relative group">
                <img
                  src={photoUrl}
                  alt={`Listing ${index + 1}`}
                  className="w-full h-48 object-cover rounded-lg"
                />
                {removeExistingPhoto && (
                  <button
                    type="button"
                    onClick={() => removeExistingPhoto(index)}
                    className="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* New Photo Previews */}
      {photoPreviews.length > 0 && (
        <div>
          {existingPhotos.length > 0 && (
            <h4 className="text-sm font-medium text-gray-700 mb-3">New Photos</h4>
          )}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {photoPreviews.map((preview, index) => (
              <div key={index} className="relative group">
                <img
                  src={preview}
                  alt={`Preview ${index + 1}`}
                  className="w-full h-48 object-cover rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => removePhoto(index)}
                  className="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StepPhotos;

